import * as React from 'react';
import { createElement } from 'react';
import { useMediaQuery } from '@mui/material';
import { 
    Menu, MenuItemLink, useResourceDefinitions, useSidebarState, useTranslate, useTheme } from 'react-admin';
import DefaultIcon from '@mui/icons-material/ViewList';

let Logo = 'https://diegogaona.com/wp-content/uploads/2020/04/logo-diegogaonacom.svg'



export const MyMenu = (props) => {
    const [theme, ] = useTheme()
    const translate = useTranslate();
    const resources = useResourceDefinitions()
    const [open] = useSidebarState();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    return (
        <>
            {isSmall ? (
                <Menu {...props}>
                    <div
                        style={{
                            display: "flex",
                            backgroundColor: theme.palette.primary.main,
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "13px"
                        }}>
                        <img
                            src={Logo} style={{
                                width: "95px",
                            }}
                            alt="diegogaona.com" />
                    </div>
                    {Object.keys(resources).map(name => (
                        <MenuItemLink
                            key={name}
                            to={`/${name}`}
                            primaryText={
                                (resources[name].options && resources[name].options.label)
                                || translate(`resources.${name}.nameplural`)
                                || name
                            }
                            leftIcon={
                                resources[name].icon ? createElement(resources[name].icon) : <DefaultIcon />
                            }
                            onClick={props.onMenuClick}
                            sidebarIsOpen={open}
                        />
                    ))}
                    {/* add your custom menus here */}
                </Menu>
            ) : (
                <Menu {...props}>
                    <div
                    style={{
                        padding: "13px"
                    }}></div>
                    {Object.keys(resources).map(name => (
                        <MenuItemLink
                            key={name}
                            to={`/${name}`}
                            primaryText={
                                (resources[name].options && resources[name].options.label)
                                || translate(`resources.${name}.nameplural`)
                                || name
                            }
                            leftIcon={
                                resources[name].icon ? createElement(resources[name].icon) : <DefaultIcon />
                            }
                            onClick={props.onMenuClick}
                            sidebarIsOpen={open}
                        />
                    ))}
                    {/* add your custom menus here */}
                </Menu>
            )}
        </>
    )
}